import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _DellCloseRingDuotone(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("circle", { cx: 12, cy: 12, r: 9, fill: "#ff6565" }),
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeWidth: 1.2, d: "m9 9 6 6M15 9l-6 6" })));
}
const DellCloseRingDuotone = forwardRef(_DellCloseRingDuotone);
export { DellCloseRingDuotone };
